<div class="recent-strip"
      #gridRecentItems>

  <!-- Create new scenario -->
  <a class="tile-link" (click)="onAddDealClick()">
    <div class="scn scn-new">
      <div class="scn-plus">
        <i class="fa fa-plus"></i>
      </div>
      <span class="scn-new-text">Create new scenario</span>
    </div>
  </a>

  <!-- Recent deals -->
  @for (deal of visibleItems(); track deal.id) {

  <a class="tile-link" (click)="onViewDealClick(deal)">
    <div class="scn" [style.--tile-accent]="getAccentColour(deal)">
      <div class="scn-body">

        @if (deal.dealGroupName) {
        <span class="tag">
          <span class="tag-dot"></span>{{ deal.dealGroupName }}
        </span>
        }

        <span class="s-name">{{ deal.name }}</span>
       @if (deal.targetPrice != null) {
          <div class="s-price">
            {{ deal.targetPrice | numericFormatPipe : 2 : false : deal.currencyCode }}
            <span class="cur">{{ deal.currencyCode }} / yr</span>
          </div>
        }
        @else {
          <div class="s-price empty">Not yet priced</div>
        }

        <div class="s-foot">
          <span class="s-meta">{{ metaLabel(deal) }}</span>

          @if (deal.towerNames?.length) {
            <span #towersPill
                  class="pill-towers"
                  (mouseenter)="helpTooltip.showText(towersPill, towerTooltip(deal))"
                  (mouseleave)="helpTooltip.hide()">
              Towers
            </span>
          }
        </div>
      </div>
    </div>
  </a>
  }

</div>

<app-pb-createnew-deal-dlg [(show)]="showCreateNewDealDlg">
</app-pb-createnew-deal-dlg>
